import { render } from "./BugInstructionList.vue?vue&type=template&id=d7b99f8c&scoped=true"
import script from "./BugInstructionList.vue?vue&type=script&lang=js"
export * from "./BugInstructionList.vue?vue&type=script&lang=js"

import "./BugInstructionList.vue?vue&type=style&index=0&id=d7b99f8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7b99f8c"]])

export default __exports__